import { default as Obj } from "./abstract/Object";
import FilterGroup from "./FilterGroup";
import ContractTemplate from "../models/ContractTemplate";

export default class FilterGroupCollection extends Obj {
  groups;
  contract_template;

  constructor(props, shouldApplyContractTemplate = true) {
    super();

    this.initializeAttributes(
      props,
      {
        groups: value => FilterGroup.list(value),
        contract_template: ContractTemplate
      },
      false
    );

    if (shouldApplyContractTemplate)
      this.applyContractTemplate(this.contract_template);
  }

  get filters_with_children() {
    let filters = [];

    this.groups.forEach(group => {
      group.items.forEach(filter => {
        if (filter.filter_child) {
          filters.push(filter);
        }
      });
    });

    return filters;
  }

  get save_key() {
    return (
      this.client.id +
      "-" +
      (this.contract_template ? this.contract_template.id : "general")
    );
  }

  copyStateFrom(fgc) {
    if (!fgc) return;

    fgc.getFilters().forEach(fgcFilter => {
      const filter = this.findFilterByKey(fgcFilter.key);

      if (!filter) {
        return;
      }

      filter.state = fgcFilter.state;
      filter.updateSelection();
    });
  }

  getFiltersWithValues() {
    const filters = [];

    this.groups.forEach(group => {
      group.items.forEach(filter => {
        if (
          (!Array.isArray(filter.state.value) && filter.state.value != null) ||
          (Array.isArray(filter.state.value) && filter.state.value.length)
        ) {
          filters.push(filter);
        }
      });
    });

    return filters;
  }

  getFilters() {
    const filters = [];

    this.groups.forEach(group => {
      group.items.forEach(filter => {
        filters.push(filter);
      });
    });

    return filters;
  }

  findFilterByKey(key) {
    for (let i = 0; i < this.groups.length; i++) {
      const group = this.groups[i];
      const filter = group.items.find(filter => filter.key == key);

      if (filter) {
        return filter;
      }
    }
  }

  findFilterValueByFilterKey(key) {
    const filter = this.findFilterByKey(key);

    return filter && filter.state ? filter.state.value : null;
  }

  applyChildFilters() {
    const filters = this.filters_with_children;

    const previousKeys = [];

    filters.forEach(filter => {
      for (const filterKey in filter.filter_child) {
        if (filter.filter_child.hasOwnProperty(filterKey)) {
          const dataAttribute = filter.filter_child[filterKey]; // Get the key of the data attibute in which we need to to loop
          const childFilter = this.findFilterByKey(filterKey); // Find the childFilter thats gonna be filtered

          if (previousKeys.indexOf(filterKey) == -1) {
            // Check whether the filter as already been filtered by another parent
            childFilter.options = [...childFilter.options_all]; // If not, make sure to use the full list
          }

          if (filter?.state?.value && filter?.state?.value?.length) {
            // If values are selected
            childFilter.filterOptions(dataAttribute, filter.state.value); // Remove the options that aren't targeted as a child of one of the selected parents.
            childFilter.updateState();
          }

          previousKeys.push(filterKey);
        }
      }
    });
  }

  applyChildFilter(filterKey, attribute, value) {
    const filter = this.findFilterByKey(filterKey);

    filter.filterOptions(attribute, value);
  }

  applyContractTemplate(ct = null) {
    let filters = [];

    this.groups.map(filterGroup => {
      filters = filters.concat(filterGroup.items);
    });

    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];

      if (ct) {
        let value = ct.inclusion_criteria_json[filter.key] || null;
        filter.state.value = value;

        if (ct.is_hiding_exclusions && ct.exclusion_criteria_json[filter.key]) {
          filter.removeOptions(ct.exclusion_criteria_json[filter.key]);
          filter.options_all = [...filter.options];
        }
      } else {
        filter.state.value = null;
      }

      filter.updateSelection();
      filter.updateState();
    }

    this.contract_template = ct;
  }

  getClientId() {
    if (!this.client) return;

    return this.client.id;
  }

  getContractTemplateId() {
    if (!this.contract_template) return;

    return this.contract_template.id;
  }

  reset() {
    this.applyContractTemplate(this.contract_template);
  }

  shrinkFilters() {}

  getValue() {
    const value = {};

    this.groups.forEach(filterGroup => {
      filterGroup.items.forEach(item => {
        if (item.state.value && !(item.state.value.length === 0)) {
          const val = item.comparison
            ? item.comparison + ":" + item.state.value
            : item.state.value;
          value[item.key] = val;
        } else if (item.options) {
          value[item.key] = [];

          for (let i = 0; i < item.options.length; i++) {
            const option = item.options[i];

            if (option.selection) {
              value[item.key].push(option.value);
            }
          }
        }
      });
    });

    return value;
  }

  save() {
    sessionStorage.setItem(
      "filter_group_collection",
      JSON.stringify(this.toJSON())
    );
  }

  static clear() {
    sessionStorage.removeItem("filter_group_collection");
  }

  static load() {
    return (
      sessionStorage.getItem("filter_group_collection") &&
      new FilterGroupCollection(
        JSON.parse(sessionStorage.getItem("filter_group_collection")),
        false
      )
    );
  }
}
